var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInpersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94707 11.95H4.00957C3.60332 11.95 3.19707 11.7312 2.97832 11.3875C2.72832 11.0437 2.69707 10.6062 2.85332 10.2C3.47832 8.60625 5.13457 7.54375 6.97832 7.54375C8.82207 7.54375 10.4783 8.60625 11.1033 10.2C11.2596 10.575 11.2283 11.0437 10.9783 11.3875C10.7596 11.7312 10.3533 11.95 9.94707 11.95ZM6.97832 6.95C5.60332 6.95 4.47832 5.825 4.47832 4.45C4.47832 3.075 5.60332 1.95 6.97832 1.95C8.35332 1.95 9.47832 3.075 9.47832 4.45C9.47832 5.825 8.35332 6.95 6.97832 6.95Z",
    fill: "#354354"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpersonIcon);
export default __webpack_public_path__ + "static/media/InpersonIcon.88e76c1e7b39174d9bd86aca5066db3f.svg";
export { ForwardRef as ReactComponent };